import { Component, OnInit } from '@angular/core';
import { SupporterService } from 'src/app/services/supporter.service';

@Component({
  selector: 'app-supporters',
  templateUrl: './supporters.component.html',
  styleUrls: ['./supporters.component.scss']
})
export class SupportersComponent implements OnInit {
  public breadcrumbLinks=[];
  public thisPage:string='In association with';
  public supporters:any[];
  public supporterImagePath:string;
  public image:string='/assets/imgs/tutors-header.jpg';
  public title:string='In Association With';
  public blurb:string='We are so appreciative to the companies, organisations and industry experts who have supported us with their time, skills and expertise helping us provide our acclaimed courses and Learning Streams.';

  constructor(
    private _supporter: SupporterService
  ) {}

  ngOnInit() {
    this._supporter.getSupporters().subscribe(
      (res:any) => {
        this.supporters=res;
      }
    );
  }

}
